import React, { useState } from "react";
import { auth, googleProvider } from "./firebase";
import { signInWithEmailAndPassword, signInWithPopup } from "firebase/auth";
import { useNavigate, useLocation } from "react-router-dom";
import bannerImage from "./assets/login/banner.webp";
import brandLogo from "./assets/LOGO.png";

export default function Dangnhap() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  // States cho Email & Mật khẩu
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // ================= LOGIC ĐĂNG NHẬP GOOGLE =================
  const handleGoogleLogin = async () => {
    setLoading(true);
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      const sessionData = {
        uid: user.uid,
        email: user.email,
        fullName: user.displayName || "Người dùng Google",
      };
      localStorage.setItem("flower_user", JSON.stringify(sessionData));
      alert(`Đăng nhập thành công với Google!\nChào mừng, ${sessionData.fullName}!`);
      // Chuyển đến trang mong muốn (ví dụ: /thanh-toan) nếu có, ngược lại về trang chủ "/"
      navigate(location.state?.redirectTo || "/");
    } catch (error) {
      console.error(error);
      alert("Đăng nhập bằng Google thất bại: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  // ================= EMAIL & PASSWORD =================
  const handleEmailAuth = async (e) => {
    e.preventDefault();
    if (!email || !password) return alert("Vui lòng điền đầy đủ email và mật khẩu!");
    setLoading(true);
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      const savedProfile = localStorage.getItem(`user_profile_${user.email}`);
      let sessionData = {};
      if (savedProfile) {
        sessionData = JSON.parse(savedProfile);
        alert(`Đăng nhập thành công!\nChào mừng trở lại, ${sessionData.fullName}!`);
      } else {
        sessionData = {
          uid: user.uid,
          email: user.email,
          fullName: "Tài khoản chưa cập nhật hồ sơ",
        };
        alert("Đăng nhập thành công!");
      }
      localStorage.setItem("flower_user", JSON.stringify(sessionData));
      // Chuyển đến trang mong muốn (ví dụ: /thanh-toan) nếu có, ngược lại về trang chủ "/"
      navigate(location.state?.redirectTo || "/");
    } catch (error) {
      console.error(error);
      if (
        error.code === "auth/user-not-found" ||
        error.code === "auth/wrong-password" ||
        error.code === "auth/invalid-credential"
      ) {
        alert("Email hoặc mật khẩu không chính xác!");
      } else {
        alert(`Lỗi: ${error.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@500;700&family=Montserrat:wght@300;400;500&display=swap');
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes slowZoom {
          0% { transform: scale(1); }
          100% { transform: scale(1.12); }
        }
        .animate-fade-in {
          animation: fadeInUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
        .floral-bg {
          position: absolute;
          top: -5%; left: -5%; right: -5%; bottom: -5%;
          background-image: url('${bannerImage}');
          background-size: cover;
          background-position: center;
          animation: slowZoom 20s ease-in-out infinite alternate;
          z-index: 1;
        }
        .dark-overlay {
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          background: linear-gradient(135deg, rgba(0, 0, 0, 0.3) 0%, rgba(0,0,0,0.5) 100%);
          z-index: 2;
        }
        .btn-brand-action {
          background: linear-gradient(135deg, #ffcdf2 0%, #ffcdf2 100%);
          color: #000;
        }
        .btn-brand-action:hover {
          box-shadow: 0 0 20px rgba(212, 175, 55, 0.4);
          transform: translateY(-2px);
        }
        .btn-google-action:hover {
          background: rgba(255, 255, 255, 0.1) !important;
          border-color: #d437aa !important;
          transform: translateY(-2px);
        }
        .btn-brand-action:active, .btn-google-action:active {
          transform: translateY(0);
        }
        .link-footer:hover {
          color: #d437aa !important;
        }
        /* Responsive Layout */
        @media (max-width: 900px) {
          .split-container { flex-direction: column !important; }
          .left-panel { flex: none !important; height: 30vh !important; border-right: none !important; border-bottom: 1px solid rgba(212, 175, 55, 0.2); }
          .right-panel { flex: 1 !important; }
        }
      `}</style>

      {/* NỬA TRÁI: LOGO */}
      <div style={styles.leftPanel} className="left-panel">
        <img
          src={brandLogo}
          alt="Floraison Brand Logo"
          style={styles.logo}
          onError={(e) => {
            // Hiển thị chữ tạm thời nếu đường dẫn ảnh chưa chính xác
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'block';
          }}
        />
        <h1 style={{ ...styles.fallbackLogo, display: 'none' }}>Floraison</h1>
      </div>

      {/* NỬA PHẢI: LOGIN FORM VỚI BANNER CHÌM */}
      <div style={styles.rightPanel} className="right-panel">
        <div className="floral-bg"></div>
        <div className="dark-overlay"></div>
        <div style={styles.card} className="animate-fade-in">
          <div style={styles.header}>
            <h2 style={styles.title}>Floraison</h2>
            <p style={styles.subtitle}>Chào mừng bạn đến với Floraison</p>
          </div>

          {/* KHU VỰC FORM EMAIL */}
          <form onSubmit={handleEmailAuth} style={styles.form}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Địa chỉ email</label>
              <input
                type="email"
                placeholder="name@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={styles.input}
                onFocus={(e) => {
                  e.target.style.borderColor = "#d437aa";
                  e.target.style.background = "rgba(255, 255, 255, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "rgba(255, 255, 255, 0.15)";
                  e.target.style.background = "rgba(255, 255, 255, 0.05)";
                }}
              />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Mật khẩu</label>
              <input
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={styles.input}
                onFocus={(e) => {
                  e.target.style.borderColor = "#d437aa";
                  e.target.style.background = "rgba(255, 255, 255, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "rgba(255, 255, 255, 0.15)";
                  e.target.style.background = "rgba(255, 255, 255, 0.05)";
                }}
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              style={{ ...styles.buttonBrand, opacity: loading ? 0.7 : 1 }}
              className="btn-brand-action"
            >
              {loading ? "Đang xử lý..." : "Đăng nhập"}
            </button>
          </form>

          <div style={styles.dividerBox}>
            <span style={styles.dividerLine}></span>
            <span style={styles.dividerText}>CÁC LỰA CHỌN KHÁC</span>
            <span style={styles.dividerLine}></span>
          </div>

          {/* NÚT ĐĂNG NHẬP GOOGLE */}
          <button
            type="button"
            onClick={handleGoogleLogin}
            disabled={loading}
            style={styles.buttonGoogle}
            className="btn-google-action"
          >
            <img
              src="https://www.svgrepo.com/show/475656/google-color.svg"
              alt="Google"
              style={{ width: "18px", height: "18px", marginRight: "10px" }}
            />
            Tiếp tục với Google
          </button>

          <div style={styles.registerFooter}>
            <button
              type="button"
              onClick={() => navigate("/dang-ky")}
              style={styles.btnLink}
              className="link-footer"
            >
              Chưa có tài khoản? Đăng ký ngay
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    minHeight: "100vh",
    backgroundColor: "#050505",
    fontFamily: "'Cormorant Garamond', sans-serif",
  },
  leftPanel: {
    flex: "1",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(135deg, #ffb4c3 0%, #FAF0F2 100%)",
    borderRight: "1px solid rgba(176, 47, 161, 0.15)",
    padding: "40px",
  },
  logo: {
    maxWidth: "600px",
    height: "auto",
    filter: "drop-shadow(0 0 20px rgba(212, 175, 55, 0.15))",
  },
  fallbackLogo: {
    fontFamily: "'Cinzel', serif",
    color: "#ffcaf3",
    fontSize: "3rem",
    letterSpacing: "4px",
  },
  rightPanel: {
    flex: "1",
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    padding: "20px",
  },
  card: {
    position: "relative",
    zIndex: 10,
    background: "rgba(15, 15, 15, 0.12)",
    backdropFilter: "blur(16px)",
    WebkitBackdropFilter: "blur(16px)",
    padding: "50px 40px",
    borderRadius: "20px",
    border: "1px solid rgba(68, 53, 53, 0.33)",
    boxShadow: "0 30px 60px rgba(0, 0, 0, 0.27), inset 0 1px 0 rgba(255, 255, 255, 0.13)",
    width: "100%",
    maxWidth: "460px",
    boxSizing: "border-box",
  },
  header: {
    marginBottom: "36px",
    textAlign: "center",
  },
  title: {
    fontFamily: "'Pinyon Script', serif",
    fontSize: "32px",
    fontWeight: "700",
    color: "#ffbae9",
    margin: "0 0 12px 0",
    letterSpacing: "1px",
  },
  subtitle: {
    fontSize: "13px",
    color: "#a0a0a0",
    lineHeight: "1.6",
    margin: 0,
    textTransform: "uppercase",
    letterSpacing: "2px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  inputGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  label: {
    fontSize: "12px",
    fontWeight: "500",
    color: "#d0d0d0",
    letterSpacing: "1px",
    textTransform: "uppercase",
  },
  input: {
    padding: "16px 18px",
    border: "1px solid rgba(255, 255, 255, 0.15)",
    borderRadius: "12px",
    fontSize: "14px",
    outline: "none",
    background: "rgba(255, 255, 255, 0.05)",
    color: "#ffffff",
    boxSizing: "border-box",
    width: "100%",
    transition: "all 0.3s ease",
  },
  buttonBrand: {
    marginTop: "10px",
    padding: "16px",
    border: "none",
    borderRadius: "12px",
    fontSize: "14px",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "2px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    outline: "none",
  },
  dividerBox: {
    display: "flex",
    alignItems: "center",
    margin: "24px 0",
    gap: "15px",
  },
  dividerLine: {
    flex: 1,
    height: "1px",
    background: "rgba(255, 255, 255, 0.1)",
  },
  dividerText: {
    color: "#888",
    fontSize: "12px",
    fontWeight: "500",
    letterSpacing: "1px",
  },
  buttonGoogle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "15px",
    background: "transparent",
    color: "#ffffff",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    borderRadius: "12px",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.3s ease",
    outline: "none",
    width: "100%",
  },
  registerFooter: {
    marginTop: "30px",
    textAlign: "center",
  },
  btnLink: {
    background: "none",
    border: "none",
    color: "#a0a0a0",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: "400",
    textAlign: "center",
    textDecoration: "none",
    outline: "none",
    transition: "color 0.3s ease",
    letterSpacing: "0.5px",
  },
};